<template>
  <header class="app-header container py-8">
    <v-row>
      <v-col>
        <logo class="app-header__logo"></logo>
      </v-col>
      <v-row justify="end" align="center" class="header__box">
        <p class="ma-0 me-8 logout__name" v-text="name"></p>
        <v-btn outlined fab @click="logout" class="logout">
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </v-row>
    </v-row>
  </header>
</template>

<script>
import logo from '@/assets/logo.svg';

export default {
  props: ['name'],
  components: {
    logo,
  },
  computed: {},
  methods: {
    logout() {
      this.$store.dispatch('signOut').then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-header {
  &__logo {
    width: 150px;
  }
  @media only screen and (max-width: 968px) {
    .header__box {
      flex-direction: column !important;
      padding-top: 14px !important;
      align-items: flex-end !important;
    }
    .logout__name,
    .logout {
      margin-right: 42px !important;
    }
    .logout__name {
      padding-bottom: 10px !important;
    }
  }
}
</style>
